module.exports = __webpack_public_path__ + "static/how-to-join.a21895ef.png";